module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/hhQcfQ/tc-custom/9781685506346.jpg?1723407262202",
      "alt": "This image is the cover for the book Santa's Naughty List"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Santa's Naughty List\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Sequel to "), _c('i', [_vm._v("Another Luck Day")]), _c('br'), _c('br'), _vm._v("Hunter Lewis has never believed in luck. He still doesn't, not really. Two years ago, however, his life changed when Lynn Valentine requested him as his partner in his very first shoot for Naked Boys Films. Something happened that day, a spark caught fire between Hunter and Lynn that hasn't lessened at all. They've since become two of Naked Boys' most popular models, and have fallen completely in love with each other."), _c('br'), _c('br'), _vm._v("Lynn calls it another luck day, a day that set them together on this new course. Luck or not, Hunter couldn't be more pleased with these results, being in the best relationship of his life since that day."), _c('br'), _c('br'), _vm._v("Today, they're doing something a little different. A cozy, domestic film for the holidays. What Lynn doesn't know, though, is Hunter's been planning this for a few months as one of his gifts for the holidays, and a surprise guest will be joining them. And Gunner Lund, a legend in the adult film industry, will be more than happy to help Hunter remove Lynn from Santa's naughty list.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      K.S. Murphy\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0